<template>
  <div>
    <div class="col-audio-player-duration">
      <a
        href="#"
        @click.prevent="togglePlayback"
        @click.right.prevent="onRandomTrack"
        class="playing-btn"
      >
        <span v-show="!isError">
          <i class="material-icons icon-circle" v-if="!isLoading">{{
            playing ? "pause" : "play_arrow"
          }}</i>
          <i class="material-icons icon-circle rotating" v-if="isLoading"
            >cached</i
          >
        </span>
        <span v-show="isError">
          <i class="material-icons icon-circle">priority_high</i>
        </span>
      </a>

      <div class="now-playing-time-container">
        {{ seek | lengthToMinutes }} / {{ duration | lengthToMinutes }}
      </div>

      <a
        href="#"
        class="now-playing-btn"
        v-on:click.prevent="toggleNowPlayingInformation"
      >
        <span class="v-align-middle text-left"
          ><i class="material-icons">info</i>&nbsp;Track Info</span
        >
      </a>
    </div>

    <div class="player-waveform-container">
      <a
        href="#"
        class="d-block track-progress-seek"
        v-bind:style="{ backgroundImage: 'url(&quot;' + wavimage + '&quot;)' }"
        v-if="track"
        >&nbsp;</a
      >

      <div
        class="track-progress-visualiser"
        v-bind:style="{
          width: progressPercent.toFixed(1) + '%',
        }"
      >
        <img
          v-bind:src="wavimage"
          v-bind:style="{ width: trackProgressVisualizerWidth + 'px' }"
        />
      </div>

      <div
        class="audio-player-seekbar-helper-container"
        v-if="seekbarHelperShow"
        v-show="seekbarHelperShow"
      >
        <div class="helper-text"></div>
      </div>
    </div>

    <div class="col-actions text-right">
      <div class="dropdown dropdown-audio-player-volume">
        <a
          class="toggle-mute-btn dropdown-toggle"
          href="#"
          role="button"
          @click.prevent="toggleMute"
          id="dropdownAudoPlayerVolume"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          v-bind:title="volTooltip"
        >
          <i class="material-icons">{{ volumeIcon }}</i>
        </a>

        <div
          class="dropdown-menu toggle-mute-btn"
          aria-labelledby="dropdownAudoPlayerVolume"
        >
          <a
            class="toggle-mute-btn-inner"
            href="#"
            @click.prevent="toggleMute"
            v-bind:title="volTooltip"
          >
            <i class="material-icons">{{ volumeIcon }}</i>
          </a>

          <volume-slider
            v-model="volumeSlider"
            :show="isVolumeSliderOpen"
          ></volume-slider>
        </div>
      </div>

      <div class="col-divider"></div>

      <a
        class="add-to-project"
        href="#"
        @click.prevent="addToProject"
        title="Add to project"
      >
        <i class="material-icons">add</i>
      </a>

      <a
        class="download-button"
        href="#"
        @click.prevent="download"
        title="Download Track"
      >
        <i class="material-icons">cloud_download</i>
      </a>

      <div class="col-divider"></div>

      <a
        href="#"
        class="manage-projects-btn"
        v-on:click.prevent="onManageProjectsClick"
      >
        <span class="v-align-middle">Manage<br />Projects</span>
      </a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import vueSlider from "vue-slider-component";
import lengthToMinutes from "../filters/length-to-minutes";
import { playerService } from "../player-service";
import { audioService } from "../audio-service";
import ToastrType from "../toastr-types.interface";

export default Vue.component("audio-player", {
  components: {
    vueSlider,
  },

  props: {
    track: {
      required: true,
    },
    asseturl: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      volumeSlider: 100,
      isVolumeSliderOpen: false,
      trackProgressVisualizerWidth: "55",
      seekbarHelperShow: false,
      sliderProgress: 0,
      progressPercentOverride: null,
      progressPercentLastValid: null,
      volumeIcon: "volume_up",
      volTooltip: "Mute (m)",
      beforeMute: 100,
    };
  },

  computed: {
    wavimage: function () {
      return typeof this.track.album !== "undefined" &&
        this.track.album !== null
        ? this.asseturl +
            "/tracks/" +
            this.track.album.code +
            "/" +
            this.track.wavimg
        : null;
    },

    playing: function () {
      return !audioService.paused;
    },

    seek: function () {
      return audioService.seek;
    },

    duration: function () {
      return audioService.duration;
    },

    progressPercent: function () {
      let newProgressPercent = audioService.progressPercent;

      if (this.progressPercentOverride != null) {
        newProgressPercent = this.progressPercentOverride;
      }

      if (newProgressPercent != null) {
        this.progressPercentLastValid = newProgressPercent;
      } else {
        newProgressPercent = this.progressPercentLastValid;
      }

      return newProgressPercent;
    },

    muted: function () {
      return audioService.muted;
    },

    isError: function () {
      return audioService.error;
    },

    isLoading: function () {
      return audioService.loading;
    },

    canplayTimestamp: function () {
      return audioService.canplayTimestamp;
    },
  },

  methods: {
    addToProject: function () {
      playerService.openAddProjectTrack(this.track);
    },

    download: function () {
      playerService.download(this.track);
    },

    handlePlayerError: function () {
      if (window.adminProjectShare == true) {
        playerService.toast(
          "[PLYR_61446] Error: Could not play Track.",
          ToastrType.Error,
        );
      }
    },

    onRandomTrack: function () {
      playerService.loadRandomTrackonDemand(true);
    },

    onWindowResize: _.debounce(function () {
      let ctx = this;

      // Check our track progress is up to date.
      $(function () {
        ctx.trackProgressVisualizerWidth = $(ctx.$el)
          .find(".track-progress-seek")
          .outerWidth();
      });
    }, 350),

    onMouseScrollWaveform: _.debounce(function () {
      let newSeekPercent = this.progressPercentOverride;
      audioService.setTrackSeekPercent(newSeekPercent);
      audioService.progressPercent = newSeekPercent;
      audioService.setVolume(this.volumeSlider / 100);
      let ctx = this;

      setTimeout(function () {
        ctx.progressPercentOverride = null;
      }, 1);
    }, 50),

    highlightTrackListRow: function () {
      let ctx = this;

      $(function () {
        // Clear any current track rows that are displaying as now playing.
        $(".track-list-row").removeClass("track-list-now-playing");

        // Highlight any track list rows of the now playing track.
        $(".track-list-row-" + ctx.track.id).addClass("track-list-now-playing");
      });
    },

    /**
     * Handle what happens when we click on the manage projects button.
     */
    onManageProjectsClick: function () {
      playerService.openManageProjects();
    },

    onMouseMoveSeekbar: function (event, $seekbarWidth) {
      let ctx = this;
      let $seekbarHelperContainer = $(".audio-player-seekbar-helper-container");
      let offsetX = event.offsetX;
      let tempSeek = offsetX / $seekbarWidth;

      this.seekbarHelperShow = true;

      if (tempSeek > 0) {
        setTimeout(function () {
          $seekbarHelperContainer
            .find(".helper-text")
            .text(
              ctx.$options.filters.lengthToMinutes(ctx.track.length * tempSeek),
            );

          // Position it relative to our mouse.
          window.positionWrapper($seekbarHelperContainer, {
            of: event,
            at: "right top",
            my: "right top",
          });
        }, 0);
      }
    },

    onMouseoutSeekbar: function (event) {
      this.seekbarHelperShow = false;
    },

    clearTrackListLoadingClasses: function () {
      // Clear any current track rows that are displaying as now playing.
      $(".track-list-row").removeClass(
        "track-list-loading-track track-list-error-loading-track",
      );
    },

    toggleMute: function () {
      let value = this.volumeSlider;
      audioService.toggleMute();
      if (audioService.muted == false) {
        this.beforeMute = this.volumeSlider;
        this.volumeIcon = "volume_off";
        this.volumeSlider = 0;
        $(".toggle-mute-btn").attr("title", "Unmute (m)");
        $(".toggle-mute-btn-inner").attr("title", "Unmute (m)");
      }
      if (audioService.muted == true) {
        this.volumeSlider = this.beforeMute;

        $(".toggle-mute-btn").attr("title", "Mute (m)");
        $(".toggle-mute-btn-inner").attr("title", "Mute (m)");
      }
    },

    toggleNowPlayingInformation: function () {
      $("body").removeClass("explore-mobile-visible search-mobile-visible");

      if ($("body").hasClass("now-playing-mobile-visible")) {
        $("body").removeClass("now-playing-mobile-visible");

        setTimeout(function () {
          playerService.$emit("collapsed-track-info");
        }, 500);
      } else {
        $("body").addClass("now-playing-mobile-visible");
      }
    },

    togglePlayback: function () {
      audioService.togglePlay();
    },

    formatter: function (unformattedinternalValue) {
      return this.$options.filters.lengthToMinutes(unformattedinternalValue);
    },

    dragEnd: function (event) {
      audioService.setTrackSeekPercent(event.getValue() / this.duration);
    },

    onPlayerAppArrowPress: function (direction) {
      const $activeTabPane = $("#playerMainTabsContainer")
        .find(".tab-pane.show.active")
        .first();

      const $trackListRowNowPlaying = $activeTabPane
        .find(".track-list-now-playing")
        .first();

      // Limit the search to the active tab pane, as each tab contains a different track list structure.
      const activeTabId = $activeTabPane.attr("id");

      if ($trackListRowNowPlaying && $trackListRowNowPlaying.length) {
        let $trackListRowCardParent = null;

        if (activeTabId === "searchTrackResults") {
          $trackListRowCardParent = $trackListRowNowPlaying
            .parents(".card-track-parent-row")
            .closest('div[role="listitem"]')
            .first();
        } else {
          $trackListRowCardParent = $trackListRowNowPlaying.closest(
            ".sortable-track-outer-container",
          );
        }

        if ($trackListRowCardParent && $trackListRowCardParent.length) {
          let $newTrackListRow = false;

          if (direction == "up") {
            // Find the prev track list row.
            let $prevTrackListRowCard = $trackListRowCardParent.prev();

            if ($prevTrackListRowCard.length) {
              $newTrackListRow = $prevTrackListRowCard;
            }
          } else if (direction == "down") {
            // Find the next track list row.
            let $nextTrackListRowCard = $trackListRowCardParent.next();

            if ($nextTrackListRowCard.length) {
              $newTrackListRow = $nextTrackListRowCard;
            }
          }

          if ($newTrackListRow != false) {
            // Find the first track-list-row and get the ID from it so we can attempt to play it.
            let $firstTrackListRow = $newTrackListRow
              .find(".track-list-row")
              .first();

            if ($firstTrackListRow.length) {
              // Get the Track Id so we can load it.
              let trackId = $firstTrackListRow.data("track-id");

              // Now play it.

              let trackFromCache = playerService.getTrackFromCache(
                "all",
                trackId,
              );

              // Try and get it from our local cache. (faster)
              if (trackFromCache !== false) {
                audioService.stream(trackFromCache);
              } else {
                // Fallback, get it fully from Ajax (slower)
                playerService.streamSharedTrack(trackId, true);
              }
            }
          }
        }
      }
    },

    seekRelative: function (seconds) {
      // Guard against invalid audio state
      if (
        !audioService.duration ||
        audioService.duration <= 0 ||
        audioService.seek == null ||
        audioService.seek < 0
      ) {
        return; // Exit early if audio is not properly loaded
      }

      const currentSeekInSeconds = audioService.seek;
      const newSeekInSeconds = Math.max(
        0,
        Math.min(audioService.duration, currentSeekInSeconds + seconds),
      );
      const newSeekPercentage =
        (newSeekInSeconds / audioService.duration) * 100;

      // Guard against invalid percentage calculations
      if (isNaN(newSeekPercentage) || !isFinite(newSeekPercentage)) {
        return;
      }

      audioService.setTrackSeekPercent(newSeekPercentage);
    },
  },

  watch: {
    canplayTimestamp: function (value) {
      this.progressPercentOverride = null;
    },

    volumeSlider: function (value) {
      if (value > 0) {
        $(".toggle-mute-btn").attr("title", "Mute (m)");
        $(".toggle-mute-btn-inner").attr("title", "Mute (m)");
      }

      if (value > 0 && value < 20) {
        this.volumeIcon = "volume_mute";
      }
      if (value > 19 && value < 50) {
        this.volumeIcon = "volume_down";
      }
      if (value > 49 && value < 101) {
        this.volumeIcon = "volume_up";
      }

      audioService.setVolume(value / 100);
    },

    track: function (value, oldValue) {
      let ctx = this;

      this.highlightTrackListRow();

      ctx.clearTrackListLoadingClasses();

      $(function () {
        if (value && value.id) {
          // Highlight any track list rows of the now playing track.
          $(".track-list-row-" + value.id).addClass("track-list-loading-track");

          // Ensure current track is not marked as previously played.
          $(".track-list-row-" + value.id).removeClass("previously-played");
        }

        // Add the previously-played class to the last played track row (old value).
        if (oldValue && oldValue.id) {
          $(".track-list-row-" + oldValue.id).addClass("previously-played");
        }
      });

      // Update track history in LS as a unique MRU list.
      let trackhistory = [];

      try {
        const ls = playerService.getLs("trackhistory");
        trackhistory = ls ? JSON.parse(ls) : [];
      } catch (e) {
        trackhistory = [];
      }

      if (!Array.isArray(trackhistory)) trackhistory = [];

      // Remove current track if it exists anywhere in history, then add to front.
      trackhistory = trackhistory.filter((id) => id !== value.id);
      trackhistory.unshift(value.id);

      playerService.setLs(
        "trackhistory",
        JSON.stringify(trackhistory),
        60 * 60 * 24000,
      );
    },

    progressPercent: function (value) {
      this.sliderProgress = value;
    },

    isError: function (value) {
      this.clearTrackListLoadingClasses();

      if (value == true) {
        // Highlight any track list rows that match this and show error.
        $(".track-list-row-" + this.track.id).addClass(
          "track-list-error-loading-track",
        );

        if (window.adminProjectShare == true) {
          playerService.toast(
            "[PLYR_271201] Error: Could not play Track.",
            ToastrType.Error,
          );
        }
      }
    },

    isLoading: function (value) {
      this.clearTrackListLoadingClasses();

      if (value == true) {
        // Highlight any track list rows that match this and show error.
        $(".track-list-row-" + this.track.id).addClass(
          "track-list-loading-track",
        );
      }
    },
  },

  mounted: function () {
    let ctx = this;
    $(".vol_tool_tip").tooltip();
    let $seekBar = $(".audio-player-container .track-progress-seek");

    $seekBar.on("wheel", (event) => {
      audioService.setVolume(0);

      let scrubIncrementInSeconds = 10;
      let scrollSeek =
        event.originalEvent.deltaY /
        (audioService.duration / scrubIncrementInSeconds);

      if (this.progressPercentOverride == null) {
        this.progressPercentOverride = audioService.progressPercent;
      }

      if (navigator.platform.indexOf("Win") > -1) {
        this.progressPercentOverride -= scrollSeek;
      } else {
        this.progressPercentOverride += scrollSeek;
      }

      this.onMouseScrollWaveform();
    });

    $seekBar.on("click", function (e) {
      let offsetX = e.offsetX;
      let seekBarWidth = $(this).innerWidth();
      let newSeekPercentage = (offsetX / seekBarWidth) * 100;

      audioService.setTrackSeekPercent(newSeekPercentage);
    });

    // If a song is loaded and we are hovering over the seek bar, display the current mouse position converted to a time.
    $seekBar.mousemove(function (event) {
      ctx.onMouseMoveSeekbar(event, $(this).innerWidth());
    });

    $seekBar.mouseout(function (event) {
      ctx.onMouseoutSeekbar(event);
    });

    // Handle showing the volume slider in a way that doesn't break the init process.
    let $toggleMuteBtn = $(".toggle-mute-btn");

    if ($toggleMuteBtn.length) {
      $toggleMuteBtn.on("mouseover", function (e) {
        setTimeout(function () {
          ctx.isVolumeSliderOpen = true;
        }, 1);
      });

      $toggleMuteBtn.on("mouseenter", function (e) {
        $(".dropdown-audio-player-volume .dropdown-menu").addClass("show");
        setTimeout(function () {
          ctx.isVolumeSliderOpen = true;
        }, 1);
      });

      $toggleMuteBtn.on("mouseleave", function (e) {
        $(".dropdown-audio-player-volume .dropdown-menu").removeClass("show");
        setTimeout(function () {
          ctx.isVolumeSliderOpen = false;
        }, 1);
      });
    }

    // Keep the background waveform up to date.
    window.addEventListener("resize", this.onWindowResize);
    this.onWindowResize();

    // When any now playing track sources update, get the data and update our player with it.
    audioService.$on("stream-track", (info) => {
      if (info.track.shouldNotUpdateNowplaying == true) {
        this.track = info.track;
      }

      this.clearTrackListLoadingClasses();
      this.highlightTrackListRow();
    });

    // Listen for any keybaord events that we are interested in.
    playerService.$on("player-app-arrow-press", this.onPlayerAppArrowPress);

    playerService.$on("increase-volume", () => {
      if (this.volumeSlider < 100) {
        this.volumeSlider += 10;
      }
    });

    playerService.$on("decrease-volume", () => {
      if (this.volumeSlider > 0) {
        this.volumeSlider -= 10;
      }
    });

    playerService.$on("audio-toggle-mute", () => {
      this.toggleMute();
    });

    playerService.$on("player-app-seek-press", (direction) => {
      const skipSeconds = direction === "backward" ? -5 : 5;
      this.seekRelative(skipSeconds);
    });
  },
});
</script>
